export enum ProductType{
  migrations = 1,
  backup = 2,
  cloudManager = 3,
  account = 4 //Account is not a real product but is used as one for notification preferences
}
